import Input from './input';
import SubIboxTile from './sub-ibox-title';
import TabBar from './tabbar';
import Pages from './pages';
import Table from './table';
import RadioBar from './radio-bar';
import RadioMaterial from './radio-material';
import LayersMaterial from './layers-material';
import Material from './material';
import Select from './select';
import Search from './search';
import Popup from './popup';
import ImgHover from './img-hover';
import UpFile from './up-file';
const install = function(Vue) {
	Vue.component(Input.name, Input);
	Vue.component(SubIboxTile.name, SubIboxTile);
	Vue.component(TabBar.name, TabBar);
	Vue.component(Pages.name, Pages);
	Vue.component(Table.name, Table);
	Vue.component(RadioBar.name, RadioBar);
	Vue.component(RadioMaterial.name, RadioMaterial);
	Vue.component(LayersMaterial.name, LayersMaterial);
	Vue.component(Material.name, Material);
	Vue.component(Select.name, Select);
	Vue.component(Search.name, Search);
	Vue.component(Popup.name, Popup);
	Vue.component(ImgHover.name, ImgHover);
	Vue.component(UpFile.name, UpFile);
};

export default {
	install
}





// WEBPACK FOOTER //
// ./src/components/zui/index.js